import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_1/BuildingInstructions_Images/MainModels`

const Pic1 = `${FullPath}/FlyingChairs/1_1x.png`;
const Pic2 = `${FullPath}/FlyingChairs/2_1x.png`;
const Pic3 = `${FullPath}/FlyingChairs/3_1x.png`;
const Pic4 = `${FullPath}/FlyingChairs/4_1x.png`;
const Pic5 = `${FullPath}/FlyingChairs/5_1x.png`;
const Pic6 = `${FullPath}/FlyingChairs/6_1x.png`;
const Pic7 = `${FullPath}/FlyingChairs/7_1x.png`;
const Pic8 = `${FullPath}/FlyingChairs/8_1x.png`;
const Pic9 = `${FullPath}/FlyingChairs/9_1x.png`;
const Pic10 = `${FullPath}/FlyingChairs/10_1x.png`;
const Pic11 = `${FullPath}/FlyingChairs/11_1x.png`;
const Pic12 = `${FullPath}/FlyingChairs/12_1x.png`;
const Pic13 = `${FullPath}/FlyingChairs/13_1x.png`;
const Pic14 = `${FullPath}/FlyingChairs/14_1x.png`;
const Pic15 = `${FullPath}/FlyingChairs/15_1x.png`;



export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,

    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}